import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userEmail: "",
    reclamation: null,
  },
  mutations: {
    setUserEmail(state, email) {
      state.userEmail = email;
    },
    setReclamation(state, payload) {
      state.reclamation = payload;
    }
  },
  getters: {
    getReclamation: (state) => state.reclamation,
  },
});

export default store;
